module.exports = __webpack_public_path__ + "media/soundbites_pen.0df6d149.mp3";